import React from 'react';

function About() {
  return (
    <section className="section">
      <div className="container">
        <h2 className="title">About Me</h2>
        <div className="columns">
          <div className="column is-half">
            <div className="card">
              <div className="card-content">
                <div className="media">
                  <div className="media-content">
                    <p className="title is-4">Level 20 Full-Stack Developer</p>
                    <p className="subtitle is-6">Master of Code and Dungeons</p>
                  </div>
                </div>
                <div className="content">
                  <strong>Languages:</strong> JavaScript, Python, C++ <br/>
                  <strong>Frameworks:</strong> React, Node.js, Express <br/>
                  <strong>Tools:</strong> Git, Docker, AWS <br/>
                  <strong>Favorite Spells:</strong> Fireball, Healing Word
                </div>
              </div>
            </div>
          </div>
          <div className="column is-half">
            {/* Additional content, image, etc. */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
